// ITAM-2622 (3.3/3.5): the landing route, extracted so it has exactly one
// definition. Transactions used to hard-code "/order-processing" as its
// not-allowed redirect, which is a route the consult-only pharmacist may not
// even reach.

export interface DefaultRouteInput {
  isAdmin: boolean;
  isMarketplaceAdmin: boolean;
  /** The CALL-CENTER pharmacist role, not the ITAM-2622 consultant. */
  isPharmacist: boolean;
  isConsultOnly: boolean;
}

export const resolveDefaultRoute = ({
  isAdmin,
  isMarketplaceAdmin,
  isPharmacist,
  isConsultOnly,
}: DefaultRouteInput): string => {
  if (isMarketplaceAdmin && !isAdmin) return "/admin-marketplace";
  // A consult-only session can never also be admin / marketplace-admin /
  // call-center pharmacist — those roles are in CONFLICTING_STAFF and suppress
  // pharmacist capability entirely — so this branch cannot steal another
  // persona's landing route (decision 7).
  if (isConsultOnly) return "/pharmacist-profile";
  return isPharmacist ? "/pharmacist-support" : "/order-processing";
};
